import type {UpdateCustomerPayload} from "@mytour/shared";
import {toEditableCustomerPayload} from "./customerCreatePayload.js";

export function toUpdateCustomerPayload(
  customer: Partial<UpdateCustomerPayload>
): UpdateCustomerPayload {
  return {
    ...toEditableCustomerPayload(customer),
    id: customer.id as string,
  };
}
